import "core-js/modules/web.dom-collections.iterator.js";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "../../../../Styled/Box";
import Spacing from "../../../../Styled/Spacing";
import Text, { TextSpan } from "../../../../Styled/Text";
import { useCallbackRef } from "../../../useCallbackRef";
import { canShorten } from "./BuildShareLink";
import { PrintSection } from "./Print/PrintSection";
import { shouldShorten as shouldShortenDefault } from "./SharePanel";
import { ShareUrl, ShareUrlBookmark } from "./ShareUrl";
import Checkbox from "../../../../Styled/Checkbox";
import { EmbedSection } from "./Embed/EmbedSection";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const SharePanelContent = _ref => {
  let {
    terria,
    viewState,
    closePanel
  } = _ref;
  const {
    t
  } = useTranslation();
  const canShortenUrl = useMemo(() => !!canShorten(terria), [terria]);
  const [includeStoryInShare, setIncludeStoryInShare] = useState(true);
  const [shouldShorten, setShouldShorten] = useState(shouldShortenDefault(terria));
  const [_, update] = useState();
  const shareUrlRef = useCallbackRef(null, () => update({}));
  const includeStoryInShareOnChange = useCallback(() => {
    setIncludeStoryInShare(prevState => !prevState);
  }, []);
  const shouldShortenOnChange = useCallback(() => {
    setShouldShorten(prevState => {
      terria.setLocalProperty("shortenShareUrls", !prevState);
      return !prevState;
    });
  }, [terria]);
  return /*#__PURE__*/_jsxs(Box, {
    paddedRatio: 3,
    column: true,
    children: [/*#__PURE__*/_jsx(Text, {
      semiBold: true,
      medium: true,
      children: t("clipboard.shareURL")
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), /*#__PURE__*/_jsx(ShareUrl, {
      terria: terria,
      viewState: viewState,
      includeStories: includeStoryInShare,
      shouldShorten: shouldShorten,
      ref: shareUrlRef,
      callback: closePanel,
      children: /*#__PURE__*/_jsx(ShareUrlBookmark, {
        viewState: viewState
      })
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 1
    }), terria.stories && terria.stories.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Checkbox, {
        textProps: {
          medium: true
        },
        id: "includeStory",
        title: "Include Story in Share",
        isChecked: includeStoryInShare,
        onChange: includeStoryInShareOnChange,
        children: /*#__PURE__*/_jsx(TextSpan, {
          children: t("includeStory.message")
        })
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 2
      })]
    }), /*#__PURE__*/_jsx(Checkbox, {
      textProps: {
        medium: true
      },
      id: "shortenUrl",
      isChecked: shouldShorten,
      onChange: shouldShortenOnChange,
      isDisabled: !canShortenUrl,
      children: /*#__PURE__*/_jsx(TextSpan, {
        children: t("share.shortenUsingService")
      })
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 4
    }), /*#__PURE__*/_jsx(PrintSection, {
      viewState: viewState
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 4
    }), /*#__PURE__*/_jsx(EmbedSection, {
      shareUrl: shareUrlRef === null || shareUrlRef === void 0 ? void 0 : shareUrlRef.current
    })]
  });
};